// extracted by mini-css-extract-plugin
module.exports = {"heading":"styles_heading__2Ri-C","paragraph":"styles_paragraph__9uTy5"};